const filterListModalfilterUser = {
  filter: 'FILTERS',
  clear: 'clean filters'
};

export default filterListModalfilterUser;
